import { Link, useParams } from "react-router-dom";

export default () => {
    const { businessName } = useParams();
    return (
        <div className="h-[50vh] flex flex-col justify-center items-center">
            <h1 className="text-2xl">Page Not Found</h1>
            <Link to={`/${businessName}`} className="rounded py-2 px-4 mt-4 text-white bg-primary hover:bg-secondary">
                Go to menu
            </Link>
        </div>
    );
};
